/* TWC Lab theme — behaviour layer. No dependencies. Prices updated +15% 26 Oct 2026 (search index cache key bumped). */
(function () {
  'use strict';
  var T = window.TWC || {};
  var S = T.strings || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); };

  var arr = function (x) { return x == null || x === '' ? [] : (Array.isArray(x) ? x : [x]); };

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = T.moneyFormat || '€{{amount}}';
    cents = Math.round(Number(cents) || 0);
    function fmtNum(n, dec, th, dp) {
      var s = (n / 100).toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return s.length > 1 ? s[0] + dp + s[1] : s[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return fmtNum(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_space_separator': return fmtNum(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return fmtNum(cents, 2, ' ', '.');
        default: return fmtNum(cents, 2, ',', '.');
      }
    });
  }
  T.money = money;

  /* kg in a pack label such as "5 kg", "500 g", "1 L", "250 ml" */
  function kgOf(text) {
    var m = String(text || '').toLowerCase().replace(',', '.').match(/(\d+(?:\.\d+)?)\s*(kg|kgs|g|gm|gms|gram|grams|l|ltr|litre|liter|ml)\b/);
    if (!m) return 0;
    var n = parseFloat(m[1]), u = m[2];
    if (u === 'g' || u === 'gm' || u === 'gms' || u === 'gram' || u === 'grams' || u === 'ml') return n / 1000;
    return n;
  }
  T.kgOf = kgOf;

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(html, isError) {
    var el = $('#Toast');
    if (!el) return;
    el.innerHTML = html;
    el.style.background = isError ? '#8A1F11' : '';
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 5000);
  }
  T.toast = toast;

  /* ---------- cart API ---------- */
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || S.error || 'Error');
        return j;
      });
    });
  }
  function getCart() { return fetch((T.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function addItems(items) { return postJSON((T.cartAddUrl || '/cart/add') + '.js', { items: items }); }
  function changeLine(line, qty) { return postJSON((T.cartChangeUrl || '/cart/change') + '.js', { line: line, quantity: qty }); }
  T.getCart = getCart; T.addItems = addItems;

  function shipText(total) {
    var rem = Math.max(0, (T.freeShipCents || 0) - total);
    if (rem === 0 && total > 0) return S.freeShipUnlocked || 'Free EU shipping unlocked';
    return (S.freeShipRemaining || '{{ amount }} more for free EU shipping').replace(/\{\{\s*amount\s*\}\}/, money(rem));
  }
  function pct(total) { return T.freeShipCents ? Math.min(100, Math.round(total / T.freeShipCents * 100)) : 0; }

  function updateHeader(cart) {
    var sum = $('[data-cart-sum]');
    if (sum) sum.textContent = money(cart.total_price) + ' · ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items');
    var m = $('[data-cart-meter]'); if (m) m.style.width = pct(cart.total_price) + '%';
    var n = $('[data-cart-note]'); if (n) n.textContent = shipText(cart.total_price);
    $$('[data-cart-total]').forEach(function (el) { el.setAttribute('data-cart-total', cart.total_price); });
    document.dispatchEvent(new CustomEvent('twc:cart', { detail: cart }));
  }
  function afterAdd(label) {
    return getCart().then(function (cart) {
      updateHeader(cart);
      toast('<span>' + esc(label || S.added || 'Added to cart') + ' · <span class="mono">' + money(cart.total_price) + '</span> — ' + esc(shipText(cart.total_price)) + '</span><a href="' + esc(T.cartUrl || '/cart') + '">' + esc(S.viewCart || 'View cart') + '</a>');
      return cart;
    });
  }
  function busy(btn, on) { if (!btn) return; btn.disabled = on; btn.setAttribute('aria-busy', on ? 'true' : 'false'); }

  /* quick-add forms (collection rows, recommendations) */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-quick-add]');
    if (!f) return;
    e.preventDefault();
    var id = f.querySelector('[name="id"]');
    var q = f.querySelector('[name="quantity"]');
    var btn = f.querySelector('[type="submit"]');
    busy(btn, true);
    addItems([{ id: Number(id.value), quantity: Number(q ? q.value : 1) || 1 }])
      .then(function () { return afterAdd(); })
      .catch(function (err) { toast(esc(err.message), true); })
      .then(function () { busy(btn, false); });
  });
  /* single add buttons (cart upsell, reorder) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add-id]');
    if (!b) return;
    e.preventDefault();
    busy(b, true);
    addItems([{ id: Number(b.getAttribute('data-add-id')), quantity: Number(b.getAttribute('data-add-qty')) || 1 }])
      .then(function () {
        if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
        return afterAdd();
      })
      .catch(function (err) { toast(esc(err.message), true); })
      .then(function () { busy(b, false); });
  });

  /* ---------- mobile drawer ---------- */
  (function () {
    var drawer = $('[data-drawer]');
    if (!drawer) return;
    var opener = $('[data-drawer-open]');
    function set(open) {
      drawer.classList.toggle('is-open', open);
      if (opener) opener.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) { var f = drawer.querySelector('a,button'); if (f) f.focus(); } else if (opener) opener.focus();
    }
    if (opener) opener.addEventListener('click', function () { set(true); });
    $$('[data-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) set(false); });
  })();

  /* mega menu: keyboard / touch open */
  $$('.nav__item').forEach(function (item) {
    var trigger = item.querySelector('[aria-haspopup], [aria-expanded]');
    if (!trigger || !item.querySelector('.mega')) return;
    trigger.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: hover)').matches && trigger.tagName === 'A') return;
      e.preventDefault();
      var open = !item.classList.contains('is-open');
      $$('.nav__item.is-open').forEach(function (o) { o.classList.remove('is-open'); });
      item.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav__item')) $$('.nav__item.is-open').forEach(function (o) { o.classList.remove('is-open'); });
  });

  /* ---------- smart search engine (no app) ----------
     Loads a compact index of every product from /collections/all?view=search-index,
     keeps it in IndexedDB for 12 h, and searches titles, Latin names, common and
     Indian names, synonyms, INCI, CAS, SKU, form, family and plant part with
     prefix matching, typo tolerance and form keywords. */
  var Smart = (function () {
    var items = null, vocab = null, loading = null;
    var KEY = 'twc-smart-' + (T.indexVersion || '1');
    var TTL = 12 * 3600 * 1000;
    var FORM_WORDS = {
      'os': 'oil soluble', 'ose': 'oil soluble', 'oilsoluble': 'oil soluble', 'ws': 'water soluble', 'wse': 'water soluble',
      'pg': 'propylene glycol', 'eo': 'essential oil', 'co2': 'co2', 'scfe': 'co2', 'floral': 'hydrosol', 'distillate': 'hydrosol',
      'glycerite': 'glycerin', 'glycerine': 'glycerin', 'veg': 'vegetable', 'pwd': 'powder', 'powders': 'powder', 'oils': 'oil', 'extracts': 'extract'
    };
    function norm(x) {
      return String(x == null ? '' : x).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/[’']/g, '').replace(/[^a-z0-9.\-]+/g, ' ').replace(/(^|\s)[.\-]+|[.\-]+(\s|$)/g, ' ').trim();
    }
    function toks(x) {
      var out = [];
      norm(x).split(/\s+/).forEach(function (w) {
        if (!w) return;
        out.push(w);
        if (w.indexOf('-') > -1 && !/^\d/.test(w)) w.split('-').forEach(function (p) { if (p) out.push(p); });
      });
      return out;
    }
    var FIELDS = [['t', 3], ['l', 3], ['c', 2.6], ['i', 2.6], ['s', 2], ['f', 1.6], ['n', 1.4], ['k', 4], ['sku', 4], ['fm', 1], ['pt', 1], ['cr', 1.2]];

    function build(list) {
      items = list; vocab = {};
      list.forEach(function (it, idx) {
        it._i = idx;
        it._t = norm(it.t); it._l = norm(it.l);
        var seen = {};
        FIELDS.forEach(function (fw) {
          arr(it[fw[0]]).forEach(function (v) {
            (fw[0] === 'sku' ? [norm(v), norm(String(v).split('-').slice(0, 3).join('-')), norm(String(v).split('-')[0])] : toks(v)).forEach(function (w) {
              if (!w) return;
              var key = w + '|' + idx;
              if (seen[key] && seen[key] >= fw[1]) return;
              seen[key] = fw[1];
              (vocab[w] = vocab[w] || []).push([idx, fw[1]]);
            });
          });
        });
      });
      vocab._keys = Object.keys(vocab);
    }
    function compact(list) {
      return list.map(function (o) {
        var c = {};
        Object.keys(o).forEach(function (k) {
          var v = o[k];
          if (v == null || v === '' || (Array.isArray(v) && !v.length)) return;
          if (k === 'img') v = String(v).replace(/^(https?:)?\/\/[^/]+\/cdn\/shop\/files\//, '~').replace(/&width=120$/, '');
          c[k] = v;
        });
        return c;
      });
    }
    T.imgUrl = function (v) { return !v ? '' : (v.charAt(0) === '~' ? '/cdn/shop/files/' + v.slice(1) + (v.indexOf('?') > -1 ? '&' : '?') + 'width=120' : v); };

    function idb(mode, val) {
      return new Promise(function (res) {
        try {
          var rq = indexedDB.open('twc', 1);
          rq.onupgradeneeded = function () { rq.result.createObjectStore('kv'); };
          rq.onerror = function () { res(null); };
          rq.onsuccess = function () {
            try {
              var tx = rq.result.transaction('kv', mode === 'get' ? 'readonly' : 'readwrite').objectStore('kv');
              var r2 = mode === 'get' ? tx.get(KEY) : tx.put(val, KEY);
              r2.onsuccess = function () { res(mode === 'get' ? r2.result : true); };
              r2.onerror = function () { res(null); };
            } catch (e) { res(null); }
          };
        } catch (e) { res(null); }
      });
    }
    function fetchPage(n, tries) {
      tries = tries || 0;
      return fetch((T.allUrl || '/collections/all') + '?view=search-index&page=' + n)
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (t) { return JSON.parse(t); })
        .catch(function (e) {
          if (tries >= 4) throw e;
          return new Promise(function (res) { setTimeout(res, 600 * (tries + 1)); }).then(function () { return fetchPage(n, tries + 1); });
        });
    }
    function load() {
      if (items) return Promise.resolve(items);
      if (loading) return loading;
      loading = idb('get').then(function (cached) {
        if (cached && cached.ts && Date.now() - cached.ts < TTL && cached.items && cached.items.length) { build(cached.items); return items; }
        return fetchPage(1).then(function (first) {
          var pages = first.pages || 1, out = [first], queue = [];
          for (var n = 2; n <= pages; n++) queue.push(n);
          function worker() {
            var n = queue.shift();
            if (n == null) return Promise.resolve();
            return fetchPage(n).then(function (j) { out.push(j); }).then(worker);
          }
          return Promise.all([worker(), worker(), worker(), worker()]).then(function () {
            var all = [];
            out.sort(function (a, b) { return a.page - b.page; }).forEach(function (j) { all = all.concat(j.items || []); });
            all = compact(all);
            build(all);
            idb('put', { ts: Date.now(), items: all });
            return items;
          });
        });
      }).catch(function (e) { loading = null; throw e; });
      return loading;
    }

    function lev(a, b, max) {
      if (Math.abs(a.length - b.length) > max) return max + 1;
      var prev = [], cur, i, j;
      for (j = 0; j <= b.length; j++) prev[j] = j;
      for (i = 1; i <= a.length; i++) {
        cur = [i]; var best = i;
        for (j = 1; j <= b.length; j++) {
          cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
          if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) cur[j] = Math.min(cur[j], prev[j - 2] + 1);
          if (cur[j] < best) best = cur[j];
        }
        if (best > max) return max + 1;
        prev = cur;
      }
      return prev[b.length];
    }
    function matchToken(q) {
      // returns {idx: score}, fuzzy flag
      var hits = {}, fuzzy = false, fuzzyRank = 0, keys = vocab._keys;
      function add(list, f) { list.forEach(function (e) { var sc = e[1] * f; if (!hits[e[0]] || hits[e[0]] < sc) hits[e[0]] = sc; }); }
      if (vocab[q] && q !== '_keys') add(vocab[q], 1);
      var any = !!vocab[q];
      if (q.length >= 2) {
        for (var i = 0; i < keys.length; i++) {
          var k = keys[i];
          if (k !== q && k.lastIndexOf(q, 0) === 0) { add(vocab[k], q.length >= 3 ? 0.8 : 0.6); any = true; }
          else if (q.length >= 4 && k.length > q.length && k.indexOf(q) > 0) { add(vocab[k], 0.45); any = true; }
        }
      }
      if (!any && q.length >= 4 && !/^\d/.test(q)) {
        var max = q.length >= 8 ? 2 : 1;
        for (var j = 0; j < keys.length; j++) {
          var w = keys[j];
          if (w.length < 3 || Math.abs(w.length - q.length) > max + 3) continue;
          var d = lev(q, w.slice(0, Math.max(q.length, Math.min(w.length, q.length + 1))), max);
          if (d <= max) {
            add(vocab[w], d === 1 ? 0.5 : 0.35);
            var rank = d * 1000 - vocab[w].length;
            if (!fuzzy || rank < fuzzyRank) { fuzzy = w; fuzzyRank = rank; }
          }
        }
      }
      return { hits: hits, fuzzy: fuzzy };
    }
    function search(query, limit) {
      if (!items) return null;
      var raw = norm(query);
      if (!raw) return { products: [], botanicals: [], forms: [], total: 0 };
      var qt = toks(raw).map(function (w) { return FORM_WORDS[w] || w; }).join(' ').split(' ').filter(Boolean);
      var stop = { and: 1, of: 1, the: 1, for: 1, with: 1, in: 1 };
      qt = qt.filter(function (w) { return !stop[w]; });
      if (!qt.length) return { products: [], botanicals: [], forms: [], total: 0 };
      var scores = null, fuzzyWords = [], perTok = [], relaxed = false;
      qt.forEach(function (w) {
        var r = matchToken(w);
        perTok.push(r.hits);
        if (r.fuzzy) fuzzyWords.push(r.fuzzy);
        if (scores === null) { scores = r.hits; return; }
        var next = {};
        Object.keys(scores).forEach(function (k) { if (r.hits[k]) next[k] = scores[k] + r.hits[k]; });
        scores = next;
      });
      if (qt.length > 1 && !Object.keys(scores || {}).length) {
        // nothing matches every word: rank by how many words match
        relaxed = true; scores = {};
        perTok.forEach(function (h) { Object.keys(h).forEach(function (k) { scores[k] = (scores[k] || 0) + h[k] + 2; }); });
        var need = Math.max(1, qt.length - 1);
        Object.keys(scores).forEach(function (k) { var c = perTok.filter(function (h) { return h[k]; }).length; if (c < need) delete scores[k]; });
      }
      var res = Object.keys(scores || {}).map(function (k) {
        var it = items[k], sc = scores[k];
        if (it._t.indexOf(raw) === 0) sc += 3; else if (it._t.indexOf(raw) > -1) sc += 1.5;
        if (it._l && it._l.indexOf(raw) === 0) sc += 2.5;
        if (it.a) sc += 0.3;
        return { it: it, sc: sc };
      }).sort(function (a, b) { return b.sc - a.sc || a.it.t.length - b.it.t.length; });
      // botanicals
      var bots = {}, border = [];
      res.slice(0, 300).forEach(function (r) {
        var l = r.it.l; if (!l || l.indexOf(',') > -1) return;
        var names = norm(l + ' ' + arr(r.it.c).join(' ') + ' ' + arr(r.it.i).join(' ') + ' ' + arr(r.it.s).join(' '));
        if (!qt.concat(fuzzyWords).some(function (w) { return (' ' + names).indexOf(' ' + w) > -1; }) && !(r.it._t.indexOf(raw) > -1)) return;
        if (!bots[l]) { bots[l] = { latin: l, common: arr(r.it.c)[0] || '', url: r.it.bu || '', n: 0, sc: 0, forms: {} }; border.push(bots[l]); }
        bots[l].n++; bots[l].sc = Math.max(bots[l].sc, r.sc); if (r.it.f) bots[l].forms[r.it.f] = 1;
      });
      border.sort(function (a, b) { return b.sc - a.sc || b.n - a.n; });
      var forms = (T.forms || []).filter(function (f) {
        var ft = norm(f.t);
        return qt.every(function (w) { return ft.indexOf(w) > -1 || ft.indexOf(w.replace(/s$/, '')) > -1; });
      });
      return {
        products: res.slice(0, limit || 8).map(function (r) { return r.it; }),
        all: res, botanicals: border.slice(0, 4), forms: forms.slice(0, 3), total: res.length,
        didYouMean: fuzzyWords.length ? fuzzyWords.join(' ') : null, relaxed: relaxed
      };
    }
    function warm() { load().catch(function () {}); }
    return { load: load, search: search, ready: function () { return !!items; }, warm: warm, norm: norm };
  })();
  T.smart = Smart;

  function perKgLabel(it) {
    var kg = Number(it.kg);
    return kg > 0 ? money(Math.round(kg * 100)) + '/kg' : 'from ' + money(it.pm);
  }

  /* ---------- predictive search (smart index first, Shopify API as fallback) ---------- */
  (function () {
    var wrap = $('[data-predictive]');
    if (!wrap) return;
    var input = wrap.querySelector('input[type="search"]');
    var out = wrap.querySelector('#PredictiveResults');
    var form = wrap.querySelector('form');
    var timer, ctrl, idx = -1;
    function close() { out.hidden = true; input.setAttribute('aria-expanded', 'false'); idx = -1; }
    function allLink(q, n) {
      return '<a class="predictive__all" href="' + esc(form.action) + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q) + '">' +
        (n ? 'See all ' + n + ' matches for “' + esc(q) + '” →' : 'Search all products for “' + esc(q) + '” →') + '</a>';
    }
    function show(h) { out.innerHTML = h; out.hidden = false; input.setAttribute('aria-expanded', 'true'); idx = -1; }
    function renderSmart(r, q) {
      if (!r.total && !r.forms.length) {
        show('<div class="predictive__group"><p class="predictive__title small muted">No matches for “' + esc(q) + '”. Try a Latin name, INCI, CAS or SKU.</p></div>' + allLink(q));
        return;
      }
      var h = '';
      if (r.relaxed) h += '<div class="predictive__group"><p class="predictive__title small">No product matches every word — closest matches:</p></div>';
      else if (r.didYouMean) h += '<div class="predictive__group"><p class="predictive__title small">Showing results for <strong>' + esc(r.didYouMean) + '</strong></p></div>';
      if (r.botanicals.length || r.forms.length) {
        h += '<div class="predictive__group"><p class="predictive__title small muted">Botanicals & forms</p>';
        r.botanicals.slice(0, 3).forEach(function (b) {
          var url = b.url || (form.action + '?type=product&q=' + encodeURIComponent(b.latin));
          h += '<a class="predictive__item" role="option" href="' + esc(url) + '"><span style="display:flex;flex-direction:column;min-width:0"><span><em>' + esc(b.latin) + '</em>' + (b.common ? ' · ' + esc(b.common) : '') + '</span><span class="small muted">' + b.n + ' product' + (b.n === 1 ? '' : 's') + ' · ' + esc(Object.keys(b.forms).slice(0, 4).join(', ')) + '</span></span></a>';
        });
        r.forms.forEach(function (f) { h += '<a class="predictive__item" role="option" href="' + esc(f.u) + '"><span>' + esc(f.t) + ' <span class="small muted">· ' + f.n + ' products</span></span></a>'; });
        h += '</div>';
      }
      if (r.products.length) {
        h += '<div class="predictive__group"><p class="predictive__title small muted">Products</p>';
        r.products.forEach(function (x) {
          var img = x.img ? '<img src="' + esc(T.imgUrl(x.img)) + '" alt="" loading="lazy" width="40" height="40">' : '<span style="width:40px;height:40px;flex:none"></span>';
          var extra = [];
          if (x.f) extra.push(esc(x.f));
          var nq = Smart.norm(q);
          var inci = arr(x.n).filter(function (v) { return Smart.norm(v).indexOf(nq) > -1; })[0];
          var cas = arr(x.k).filter(function (v) { return Smart.norm(v).indexOf(nq) > -1; })[0];
          if (inci) extra.push('INCI: ' + esc(inci)); else if (cas) extra.push('CAS ' + esc(cas));
          else if (x.sku && Smart.norm(x.sku).indexOf(nq) === 0) extra.push('SKU ' + esc(x.sku));
          h += '<a class="predictive__item" role="option" href="' + esc((T.rootUrl || '/').replace(/\/?$/, '/') + 'products/' + x.h) + '">' + img +
            '<span style="display:flex;flex-direction:column;min-width:0;flex:1"><span>' + esc(x.t) + '</span><span class="small muted">' + extra.join(' · ') + '</span></span>' +
            '<span class="mono small" style="white-space:nowrap">' + perKgLabel(x) + '</span></a>';
        });
        h += '</div>';
      }
      show(h + allLink(q, r.total));
    }
    function renderApi(res, q) {
      var p = (res.products || []), c = (res.collections || []);
      if (!p.length && !c.length) { show('<div class="predictive__group"><p class="predictive__title small muted">No matches for “' + esc(q) + '”.</p></div>' + allLink(q)); return; }
      var h = '';
      if (c.length) { h += '<div class="predictive__group"><p class="predictive__title small muted">Collections</p>'; c.slice(0, 3).forEach(function (x) { h += '<a class="predictive__item" role="option" href="' + esc(x.url) + '">' + esc(x.title) + '</a>'; }); h += '</div>'; }
      if (p.length) {
        h += '<div class="predictive__group"><p class="predictive__title small muted">Products</p>';
        p.slice(0, 7).forEach(function (x) {
          var img = x.featured_image && x.featured_image.url ? '<img src="' + esc(x.featured_image.url) + (x.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=80" alt="" loading="lazy">' : '';
          h += '<a class="predictive__item" role="option" href="' + esc(x.url) + '">' + img + '<span style="display:flex;flex-direction:column;min-width:0"><span>' + esc(x.title) + '</span><span class="small muted">' + esc(x.type || '') + '</span></span></a>';
        });
        h += '</div>';
      }
      show(h + allLink(q));
    }
    function api(q) {
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = (T.searchUrl || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=8&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.sku,variants.title,tag,vendor';
      return fetch(url, { signal: ctrl ? ctrl.signal : undefined }).then(function (r) { return r.json(); })
        .then(function (j) { return (j.resources && j.resources.results) || {}; });
    }
    function run() {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      if (Smart.ready()) {
        var r = Smart.search(q, 8);
        if (r.total || !/\d/.test(q)) { renderSmart(r, q); return; }
      }
      api(q).then(function (res) { if (input.value.trim() === q) renderApi(res, q); }).catch(function () {});
    }
    ['focus', 'pointerenter', 'touchstart'].forEach(function (ev) { (ev === 'focus' ? input : wrap).addEventListener(ev, Smart.warm, { once: true, passive: true }); });
    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        run();
        if (!Smart.ready()) Smart.load().then(function () { if (input === document.activeElement) run(); }).catch(function () {});
      }, Smart.ready() ? 40 : 180);
    });
    input.addEventListener('keydown', function (e) {
      var its = $$('.predictive__item, .predictive__all', out);
      if (out.hidden || !its.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        idx = (idx + (e.key === 'ArrowDown' ? 1 : -1) + its.length) % its.length;
        its.forEach(function (it, i) { it.setAttribute('aria-selected', i === idx ? 'true' : 'false'); });
        its[idx].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && idx > -1) { e.preventDefault(); window.location.href = its[idx].href; }
      else if (e.key === 'Escape') close();
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
  })();

  /* ---------- search page: smart matches ---------- */
  (function () {
    var box = $('[data-smart-page]');
    if (!box) return;
    var q = box.getAttribute('data-q') || '';
    if (q.trim().length < 2) return;
    var serverCount = Number(box.getAttribute('data-server-count')) || 0;
    Smart.load().then(function () {
      var r = Smart.search(q, 400);
      if (!r || (!r.total && !r.forms.length)) return;
      var h = '';
      if (r.relaxed) h += '<p class="notice">No product matches every word — showing the closest matches.</p>';
      else if (r.didYouMean) h += '<p class="notice">Showing matches for <strong>' + esc(r.didYouMean) + '</strong></p>';
      if (r.botanicals.length || r.forms.length) {
        h += '<div class="smart-chips">';
        r.botanicals.forEach(function (b) { if (b.url) h += '<a class="smart-chip" href="' + esc(b.url) + '"><em>' + esc(b.latin) + '</em>' + (b.common ? ' · ' + esc(b.common) : '') + ' <span class="muted">' + b.n + '</span></a>'; });
        r.forms.forEach(function (f) { h += '<a class="smart-chip" href="' + esc(f.u) + '">' + esc(f.t) + ' <span class="muted">' + f.n + '</span></a>'; });
        h += '</div>';
      }
      if (r.total > 0) {
        var formsCount = {};
        r.all.forEach(function (x) { var f = x.it.f || 'Other'; formsCount[f] = (formsCount[f] || 0) + 1; });
        h += '<div class="smart-head"><strong>' + r.total + ' smart matches</strong> <span class="small muted">— includes Latin, common and Indian names, INCI, CAS and SKU</span></div>';
        h += '<div class="smart-filter" role="group" aria-label="Filter by form"><button type="button" aria-pressed="true" data-sf="">All</button>' +
          Object.keys(formsCount).sort(function (a, b) { return formsCount[b] - formsCount[a]; }).slice(0, 10).map(function (f) { return '<button type="button" aria-pressed="false" data-sf="' + esc(f) + '">' + esc(f) + ' <span class="muted">' + formsCount[f] + '</span></button>'; }).join('') + '</div>';
        h += '<div class="rows" data-smart-rows></div><div style="display:flex;gap:12px;flex-wrap:wrap"><button type="button" class="btn btn--ghost" data-smart-more hidden>Show more</button>' +
          (serverCount ? '<button type="button" class="btn btn--quiet" data-smart-off>Show standard results (' + serverCount + ')</button>' : '') + '</div>';
      }
      if (!h) return;
      box.innerHTML = h; box.hidden = false;
      var rowsEl = $('[data-smart-rows]', box); if (!rowsEl) return;
      var current = r.all, shown = 0;
      var server = $('[data-server-results]'); if (server) server.hidden = true;
      var fac = $('#Facets'); if (fac) { fac.hidden = true; fac.parentNode.classList.add('layout--single'); }
      function rowHtml(x) {
        var img = x.img ? '<img src="' + esc(T.imgUrl(x.img)) + '" alt="" loading="lazy" width="64" height="64">' : '';
        return '<div class="row smart-row"><a class="row__media" href="/products/' + esc(x.h) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
          '<div style="min-width:0"><a href="/products/' + esc(x.h) + '" class="row__title">' + esc(x.t) + '</a><div style="display:flex;gap:6px;flex-wrap:wrap;margin-top:4px">' + (x.f ? '<span class="chip">' + esc(x.f) + '</span>' : '') + (x.l ? '<em class="small muted">' + esc(x.l) + '</em>' : '') + '</div></div>' +
          '<div class="c-price"><span class="mono">' + money(x.pm) + '</span><div class="small muted">from</div></div>' +
          '<div class="c-perkg">' + (Number(x.kg) > 0 ? '<span class="mono">' + money(Math.round(x.kg * 100)) + '/kg</span>' : '<span class="muted small">—</span>') + '</div>' +
          '<div class="row__add"><a class="btn btn--primary btn--sm" href="/products/' + esc(x.h) + '">' + (x.a ? 'Choose pack' : 'View') + '</a></div></div>';
      }
      function more() {
        var next = current.slice(shown, shown + 24);
        rowsEl.insertAdjacentHTML('beforeend', next.map(function (e) { return rowHtml(e.it); }).join(''));
        shown += next.length;
        $('[data-smart-more]', box).hidden = shown >= current.length;
      }
      $('[data-smart-more]', box).addEventListener('click', more);
      var off = $('[data-smart-off]', box);
      if (off) off.addEventListener('click', function () {
        box.hidden = true; if (server) server.hidden = false;
        if (fac) { fac.hidden = false; fac.parentNode.classList.remove('layout--single'); }
      });
      $$('[data-sf]', box).forEach(function (b) {
        b.addEventListener('click', function () {
          var f = b.getAttribute('data-sf');
          $$('[data-sf]', box).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          current = f ? r.all.filter(function (e) { return (e.it.f || 'Other') === f; }) : r.all;
          rowsEl.innerHTML = ''; shown = 0; more();
        });
      });
      more();
    }).catch(function () {});
  })();

  /* ---------- collection / search: facets, sort, view ---------- */
  (function () {
    var form = $('[data-facets-form]');
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="number"]')) return;
        submitFacets();
      });
      $$('input[type="number"]', form).forEach(function (i) { i.addEventListener('blur', function () { if (i.value !== i.defaultValue) submitFacets(); }); });
    }
    function submitFacets() {
      var fd = new FormData(form), params = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') params.append(k, v); });
      var sort = $('[data-sort]'); if (sort && sort.value) params.set('sort_by', sort.value);
      var cur = new URLSearchParams(window.location.search);
      ['q', 'type', 'options[prefix]'].forEach(function (k) { if (cur.get(k) && !params.get(k)) params.set(k, cur.get(k)); });
      window.location.search = params.toString();
    }
    var tog = $('[data-facets-toggle]');
    if (tog) tog.addEventListener('click', function () {
      var f = $('#Facets'); if (!f) return;
      var open = !f.classList.contains('is-open');
      f.classList.toggle('is-open', open); tog.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    $$('[data-sort]').forEach(function (s) {
      s.addEventListener('change', function () {
        var p = new URLSearchParams(window.location.search);
        p.set('sort_by', s.value); p.delete('page');
        window.location.search = p.toString();
      });
    });
    var rows = $('[data-rows]');
    var views = $$('[data-view]');
    function setView(v) {
      if (!rows) return;
      rows.classList.toggle('is-grid', v === 'grid');
      views.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-view') === v ? 'true' : 'false'); });
      store.set('twc-view', v);
    }
    views.forEach(function (b) { b.addEventListener('click', function () { setView(b.getAttribute('data-view')); }); });
    if (rows && store.get('twc-view') === 'grid') setView('grid');
  })();

  /* ---------- product page ---------- */
  (function () {
    var root = $('[data-pdp]');
    var dataEl = $('[data-product-json]');
    if (!root || !dataEl) return;
    var P; try { P = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var arr = function (x) { return x == null || x === '' ? [] : (Array.isArray(x) ? x : [x]); };
    P.variants.forEach(function (v) { v.inci = arr(v.inci); v.cas = arr(v.cas); v.carrier = arr(v.carrier); });
    var form = $('[data-product-form]', root);
    var select = $('[data-variant-select]', root);
    var qtyIn = $('[data-qty-input]', root);
    var addBtn = $('[data-add]', root);
    var sizeIdx = P.sizeIndex;
    var threshold = Number(root.getAttribute('data-threshold')) || T.freeShipCents || 0;
    var groups = $$('[data-option-index]', root);
    var selected = (function () {
      var cur = P.variants.filter(function (v) { return String(v.id) === select.value; })[0] || P.variants[0];
      return cur ? cur.options.slice() : [];
    })();

    function find(opts) {
      return P.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0];
    }
    function current() { return find(selected); }
    function perKg(v) { var kg = sizeIdx > -1 ? kgOf(v.options[sizeIdx]) : kgOf(v.title); return kg ? v.price / kg : 0; }
    function siblings() {
      // variants sharing every non-size option with the current selection
      if (sizeIdx < 0) return [];
      return P.variants.filter(function (v) { return v.options.every(function (o, i) { return i === sizeIdx || o === selected[i]; }); });
    }

    function paintPacks() {
      var packs = $('[data-packs]', root);
      if (!packs) return;
      var sib = siblings();
      var basePer = 0;
      sib.forEach(function (v) { var p = perKg(v); if (p && (!basePer || p > basePer)) basePer = p; });
      $$('.pack', packs).forEach(function (btn) {
        var val = btn.getAttribute('data-value');
        var v = sib.filter(function (s) { return s.options[sizeIdx] === val; })[0];
        var kgEl = $('[data-pack-kg]', btn), badge = $('[data-pack-badge]', btn), price = $('[data-pack-price]', btn);
        btn.setAttribute('aria-pressed', selected[sizeIdx] === val ? 'true' : 'false');
        if (!v) { btn.disabled = true; price.textContent = '—'; kgEl.textContent = ''; badge.innerHTML = ''; return; }
        btn.disabled = !v.available;
        var p = perKg(v);
        kgEl.textContent = p ? money(p) + '/kg' : '';
        price.textContent = v.available ? money(v.price) : (S.soldOut || 'Sold out');
        var save = basePer && p ? Math.round((1 - p / basePer) * 100) : 0;
        badge.innerHTML = save >= 3 ? '<span class="save">Save ' + save + '%</span>' : '';
      });
    }
    function paintOptions() {
      groups.forEach(function (g) {
        if (g.hasAttribute('data-packs')) return;
        var i = Number(g.getAttribute('data-option-index'));
        $$('.opt__btn', g).forEach(function (b) {
          var val = b.getAttribute('data-value');
          b.setAttribute('aria-pressed', selected[i] === val ? 'true' : 'false');
          var test = selected.slice(); test[i] = val;
          var any = P.variants.some(function (v) { return v.available && v.options[i] === val; });
          b.classList.toggle('is-unavailable', !any);
        });
      });
    }
    function paintVariant() {
      var v = current();
      if (!v) {
        addBtn.disabled = true;
        $('[data-add-label]', root).textContent = 'Unavailable';
        $('[data-add-total]', root).textContent = '';
        return;
      }
      select.value = v.id;
      var qty = Math.max(1, Number(qtyIn.value) || 1);
      addBtn.disabled = !v.available;
      $('[data-add-label]', root).textContent = v.available ? (S.addToCart || 'Add to cart') : (S.soldOut || 'Sold out');
      $('[data-add-total]', root).textContent = '· ' + money(v.price * qty);
      var sku = $('[data-sku]'); if (sku) sku.textContent = v.sku || '—';
      var inci = $('[data-inci]'); if (inci && v.inci && v.inci.length) inci.textContent = v.inci.join(', ');
      var cas = $('[data-cas]'); if (cas && v.cas && v.cas.length) cas.textContent = v.cas.join(', ');
      var inciFor = $('[data-inci-for]'); if (inciFor) inciFor.textContent = v.carrier && v.carrier.length ? '(' + v.carrier.join(', ') + ')' : '';
      var docs = $('[data-docs-variant]'); if (docs) docs.value = v.title + ' (' + (v.sku || '') + ')';
      [['tds', '[data-doc-tds]'], ['sds', '[data-doc-sds]']].forEach(function (d) {
        var a = $(d[1]); if (!a) return;
        var row = a.closest('li') || a;
        if (v[d[0]]) { a.href = v[d[0]]; row.hidden = false; } else row.hidden = true;
      });
      if (v.media) setImage(v.media);
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
      paintMeter(); paintUpsell();
    }
    function setImage(src) {
      var wrap = $('[data-main-img-wrap]', root);
      var img = wrap && wrap.querySelector('img');
      if (!img) return;
      img.removeAttribute('srcset');
      img.src = src;
      $$('[data-thumb]', root).forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-src') === src ? 'true' : 'false'); });
    }
    function paintMeter() {
      var v = current();
      var cartTotal = Number(root.getAttribute('data-cart-total')) || 0;
      var qty = Math.max(1, Number(qtyIn.value) || 1);
      var after = cartTotal + (v ? v.price * qty : 0);
      var msg = $('[data-ship-msg]', root), of = $('[data-ship-of]', root), m = $('[data-ship-meter]', root);
      if (!msg) return;
      var rem = Math.max(0, threshold - after);
      msg.textContent = rem === 0 ? 'This order ships free across the EU' : 'With this item: ' + money(rem) + ' more for free EU shipping';
      of.textContent = money(after) + ' / ' + money(threshold);
      m.style.width = Math.min(100, Math.round(after / threshold * 100)) + '%';
    }
    function paintUpsell() {
      var box = $('[data-upsell]', root);
      if (!box) return;
      var v = current();
      box.hidden = true;
      if (!v || sizeIdx < 0) return;
      var p = perKg(v), kg = kgOf(v.options[sizeIdx]);
      if (!p || !kg) return;
      // next larger available pack with a lower per-kg price
      var better = siblings().filter(function (s) { return s.available && kgOf(s.options[sizeIdx]) > kg && perKg(s) < p; })
        .sort(function (a, b) { return kgOf(a.options[sizeIdx]) - kgOf(b.options[sizeIdx]); })[0];
      if (!better) return;
      var bp = perKg(better), save = Math.round((1 - bp / p) * 100);
      if (save < 3) return;
      $('[data-upsell-text]', box).innerHTML = 'Step up to <strong>' + esc(better.options[sizeIdx].split('/')[0].trim()) + '</strong> and pay <span class="mono">' + money(bp) + '/kg</span> instead of <span class="mono">' + money(p) + '/kg</span> — save ' + save + '% per kg.';
      var b = $('[data-upsell-btn]', box);
      b.textContent = 'Switch to ' + better.options[sizeIdx].split('/')[0].trim();
      b.onclick = function () { selected[sizeIdx] = better.options[sizeIdx]; refresh(); };
      box.hidden = false;
    }
    function refresh() {
      if (!current()) {
        // pick closest available variant matching the most recently chosen options
        var v = P.variants.filter(function (x) { return x.available && x.options.every(function (o, i) { return i === sizeIdx || o === selected[i]; }); })[0]
             || P.variants.filter(function (x) { return x.options[0] === selected[0]; })[0];
        if (v) selected = v.options.slice();
      }
      paintOptions(); paintPacks(); paintVariant();
    }

    groups.forEach(function (g) {
      var i = Number(g.getAttribute('data-option-index'));
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[data-value]');
        if (!b || b.disabled) return;
        selected[i] = b.getAttribute('data-value');
        refresh();
      });
    });
    $$('[data-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        qtyIn.value = Math.max(1, (Number(qtyIn.value) || 1) + Number(b.getAttribute('data-qty')));
        paintVariant();
      });
    });
    qtyIn.addEventListener('input', paintVariant);
    select.addEventListener('change', function () {
      var v = P.variants.filter(function (x) { return String(x.id) === select.value; })[0];
      if (v) { selected = v.options.slice(); refresh(); }
    });
    $$('[data-thumb]', root).forEach(function (t) { t.addEventListener('click', function () { setImage(t.getAttribute('data-src')); }); });
    document.addEventListener('twc:cart', function () { paintMeter(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = current(); if (!v) return;
      busy(addBtn, true);
      addItems([{ id: v.id, quantity: Math.max(1, Number(qtyIn.value) || 1) }])
        .then(function () { return afterAdd(); })
        .catch(function (err) { toast(esc(err.message), true); })
        .then(function () { busy(addBtn, !current() || !current().available); });
    });

    refresh();
  })();

  /* ---------- COA request panel (product page) ---------- */
  (function () {
    var form = $('[data-coa-form]');
    if (!form) return;
    var openers = $$('[data-coa-open]');
    var openedAt = 0;
    var KEY = 'twc-coa-requests';
    function recent() {
      try { return (JSON.parse(localStorage.getItem(KEY) || '[]') || []).filter(function (t) { return Date.now() - t < 864e5; }); } catch (e) { return []; }
    }
    function remember() { try { var r = recent(); r.push(Date.now()); localStorage.setItem(KEY, JSON.stringify(r)); } catch (e) {} }
    function open(e) {
      if (e) e.preventDefault();
      form.classList.add('is-open'); openedAt = Date.now();
      openers.forEach(function (b) { if (b.hasAttribute('aria-expanded')) b.setAttribute('aria-expanded', 'true'); });
      form.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      var f = form.querySelector('#CoaCompany'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 250);
    }
    function close() {
      form.classList.remove('is-open');
      openers.forEach(function (b) { if (b.hasAttribute('aria-expanded')) b.setAttribute('aria-expanded', 'false'); });
    }
    openers.forEach(function (b) { b.addEventListener('click', open); });
    var c = $('[data-coa-close]', form); if (c) c.addEventListener('click', close);
    if (location.hash === '#coa-request' && !form.querySelector('[data-coa-done]')) open();
    if (form.querySelector('[data-coa-done]')) form.scrollIntoView({ block: 'center' });
    form.addEventListener('submit', function (e) {
      var msg = $('[data-coa-msg]', form), btn = $('[data-coa-submit]', form), hp = $('[data-coa-hp]', form);
      // bot traps: hidden honeypot field filled, or form submitted inhumanly fast
      if ((hp && hp.value) || !openedAt || Date.now() - openedAt < 2500) {
        e.preventDefault();
        if (msg) msg.textContent = 'Please check your details and try again.';
        openedAt = Date.now();
        return;
      }
      var email = (form.querySelector('[name="contact[email]"]') || {}).value || '';
      if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email.trim())) { e.preventDefault(); if (msg) msg.textContent = 'Please enter a valid work email.'; return; }
      if (recent().length >= 5) { e.preventDefault(); if (msg) msg.textContent = 'You have sent several requests today — we will reply to those shortly.'; return; }
      remember();
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; setTimeout(function () { btn.disabled = false; btn.textContent = 'Request COA'; }, 8000); }
    });
  })();

  /* ---------- home page COA form: same bot traps ---------- */
  (function () {
    var form = $('[data-coa-form-lite]');
    if (!form) return;
    var t0 = 0;
    form.addEventListener('focusin', function () { if (!t0) t0 = Date.now(); });
    form.addEventListener('submit', function (e) {
      var msg = $('[data-coa-msg]', form), hp = $('[data-coa-hp]', form), btn = $('[data-coa-submit]', form);
      if ((hp && hp.value) || !t0 || Date.now() - t0 < 2500) { e.preventDefault(); if (msg) msg.textContent = 'Please check your details and try again.'; t0 = Date.now(); return; }
      var email = (form.querySelector('[name="contact[email]"]') || {}).value || '';
      if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email.trim())) { e.preventDefault(); if (msg) msg.textContent = 'Please enter a valid work email.'; return; }
      if (btn) { btn.disabled = true; setTimeout(function () { btn.disabled = false; }, 8000); }
    });
  })();

  /* ---------- recommendations ---------- */
  $$('[data-recommendations]').forEach(function (sec) {
    var url = sec.getAttribute('data-url');
    if (!url || sec.querySelector('[data-quick-add]')) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var fresh = d.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) sec.innerHTML = fresh.innerHTML; else sec.remove();
    }).catch(function () {});
  });

  /* ---------- cart page ---------- */
  (function () {
    var page = $('[data-cart-page]');
    if (!page) return;
    var t;
    function setLine(line, qty) {
      page.setAttribute('aria-busy', 'true');
      changeLine(Number(line), Math.max(0, qty)).then(function () { window.location.reload(); })
        .catch(function (err) { page.removeAttribute('aria-busy'); toast(esc(err.message), true); });
    }
    $$('[data-line-qty]', page).forEach(function (b) {
      b.addEventListener('click', function () {
        var line = b.getAttribute('data-line-qty');
        var input = $('[data-line-input="' + line + '"]', page);
        setLine(line, (Number(input.value) || 0) + Number(b.getAttribute('data-delta')));
      });
    });
    $$('[data-line-input]', page).forEach(function (i) {
      i.addEventListener('change', function () {
        clearTimeout(t);
        t = setTimeout(function () { setLine(i.getAttribute('data-line-input'), Number(i.value) || 0); }, 300);
      });
    });
    $$('[data-switch-line]', page).forEach(function (b) {
      b.addEventListener('click', function () {
        busy(b, true);
        var line = Number(b.getAttribute('data-switch-line'));
        var to = Number(b.getAttribute('data-switch-to'));
        var qty = Number(b.getAttribute('data-switch-qty')) || 1;
        changeLine(line, 0).then(function () { return addItems([{ id: to, quantity: qty }]); })
          .then(function () { window.location.reload(); })
          .catch(function (err) { busy(b, false); toast(esc(err.message), true); });
      });
    });
  })();

  /* ---------- quick order ---------- */
  (function () {
    var root = $('[data-quick-order]');
    if (!root) return;
    var rowsEl = $('[data-qo-rows]', root);
    var threshold = Number(root.getAttribute('data-threshold')) || T.freeShipCents || 0;
    var cartTotal = Number(root.getAttribute('data-cart-total')) || 0;
    var cache = {};
    var n = 0;

    function productJSON(handle) {
      if (cache[handle]) return Promise.resolve(cache[handle]);
      return fetch((T.rootUrl || '/').replace(/\/?$/, '/') + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { if (!r.ok) throw new Error('Not found'); return r.json(); })
        .then(function (p) { cache[handle] = p; return p; });
    }
    function suggest(q) {
      if (Smart.ready()) {
        var r = Smart.search(q, 10);
        if (r.total) return Promise.resolve(r.products.map(function (x) { return { handle: x.h, title: x.t, price_min: x.pm / 100, variants: x.sku ? [{ sku: x.sku }] : [] }; }));
      }
      Smart.warm();
      return fetch((T.searchUrl || '/search/suggest') + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=10&resources[options][fields]=title,product_type,variants.sku,variants.title,tag')
        .then(function (r) { return r.json(); })
        .then(function (j) { return (j.resources && j.resources.results && j.resources.results.products) || []; });
    }

    function addRow(prefill) {
      n += 1;
      var id = 'qo' + n;
      var row = document.createElement('div');
      row.className = 'qo-row'; row.setAttribute('data-qo-row', '');
      row.innerHTML =
        '<div class="qo-search"><label class="visually-hidden" for="' + id + '-q">Product</label>' +
        '<input class="input" id="' + id + '-q" type="search" autocomplete="off" placeholder="Product, Latin name or SKU" data-qo-q>' +
        '<div class="qo-suggest" hidden data-qo-suggest></div></div>' +
        '<div><label class="visually-hidden" for="' + id + '-v">Option / pack</label><select class="select" id="' + id + '-v" disabled data-qo-variant><option value="">—</option></select></div>' +
        '<div><label class="visually-hidden" for="' + id + '-n">Quantity</label><input class="input mono" id="' + id + '-n" type="number" min="0" max="999" value="1" data-qo-qty></div>' +
        '<div class="mono" style="text-align:right" data-qo-line>—</div>' +
        '<button type="button" class="btn btn--quiet btn--sm" aria-label="Remove row" data-qo-remove>×</button>';
      rowsEl.appendChild(row);
      wireRow(row);
      if (prefill) {
        var qi = row.querySelector('[data-qo-q]');
        qi.value = prefill.q;
        row.querySelector('[data-qo-qty]').value = prefill.qty || 1;
        if (prefill.handle) choose(row, prefill.handle, prefill.title, prefill.sku);
      }
      return row;
    }

    function choose(row, handle, title, sku) {
      var qi = row.querySelector('[data-qo-q]');
      var sel = row.querySelector('[data-qo-variant]');
      qi.value = title || handle;
      row.querySelector('[data-qo-suggest]').hidden = true;
      sel.disabled = true; sel.innerHTML = '<option>Loading…</option>';
      return productJSON(handle).then(function (p) {
        row._product = p;
        var h = '';
        var byGroup = {};
        var multi = p.options.length > 1;
        p.variants.forEach(function (v) {
          var g = multi ? v.option1 : '';
          (byGroup[g] = byGroup[g] || []).push(v);
        });
        Object.keys(byGroup).forEach(function (g) {
          if (multi) h += '<optgroup label="' + esc(g) + '">';
          byGroup[g].forEach(function (v) {
            var label = multi ? v.options.slice(1).join(' / ') : v.title;
            var kg = kgOf(label);
            h += '<option value="' + v.id + '" data-price="' + v.price + '"' + (v.available ? '' : ' disabled') + ((sku && v.sku === sku) ? ' selected' : '') + '>' +
              esc(label.split('/')[0].trim()) + ' — ' + money(v.price) + (kg ? ' (' + money(v.price / kg) + '/kg)' : '') + (v.available ? '' : ' · sold out') + '</option>';
          });
          if (multi) h += '</optgroup>';
        });
        sel.innerHTML = h;
        sel.disabled = false;
        if (!sku) { var firstAvail = sel.querySelector('option:not([disabled])'); if (firstAvail) sel.value = firstAvail.value; }
        totals();
      }).catch(function () { sel.innerHTML = '<option value="">Not available</option>'; totals(); });
    }

    function wireRow(row) {
      var qi = row.querySelector('[data-qo-q]');
      var box = row.querySelector('[data-qo-suggest]');
      var timer;
      qi.addEventListener('input', function () {
        var q = qi.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { box.hidden = true; return; }
        timer = setTimeout(function () {
          suggest(q).then(function (list) {
            if (qi.value.trim() !== q) return;
            if (!list.length) { box.innerHTML = '<p class="small muted" style="padding:10px 12px;margin:0">No matches</p>'; box.hidden = false; return; }
            box.innerHTML = list.map(function (p) {
              return '<button type="button" data-handle="' + esc(p.handle) + '" data-title="' + esc(p.title) + '"><span>' + esc(p.title) + '</span><span class="small muted mono">' + esc(money(Math.round(parseFloat(p.price_min || p.price) * 100))) + '+</span></button>';
            }).join('');
            box.hidden = false;
          }).catch(function () {});
        }, 180);
      });
      box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-handle]');
        if (b) choose(row, b.getAttribute('data-handle'), b.getAttribute('data-title'));
      });
      document.addEventListener('click', function (e) { if (!row.contains(e.target)) box.hidden = true; });
      row.querySelector('[data-qo-variant]').addEventListener('change', totals);
      row.querySelector('[data-qo-qty]').addEventListener('input', totals);
      row.querySelector('[data-qo-remove]').addEventListener('click', function () {
        row.remove();
        if (!$$('[data-qo-row]', rowsEl).length) addRow();
        totals();
      });
    }

    function collect() {
      var items = [], sum = 0;
      $$('[data-qo-row]', rowsEl).forEach(function (row) {
        var sel = row.querySelector('[data-qo-variant]');
        var qty = Math.max(0, Number(row.querySelector('[data-qo-qty]').value) || 0);
        var opt = sel.selectedOptions && sel.selectedOptions[0];
        var line = row.querySelector('[data-qo-line]');
        if (!sel.disabled && opt && opt.value && qty > 0) {
          var price = Number(opt.getAttribute('data-price')) || 0;
          items.push({ id: Number(opt.value), quantity: qty });
          sum += price * qty;
          line.textContent = money(price * qty);
        } else line.textContent = '—';
      });
      return { items: items, sum: sum };
    }
    function totals() {
      var c = collect();
      $('[data-qo-count]', root).textContent = c.items.length + (c.items.length === 1 ? ' line' : ' lines');
      $('[data-qo-total]', root).textContent = money(c.sum);
      var after = cartTotal + c.sum;
      var rem = Math.max(0, threshold - after);
      $('[data-qo-ship]', root).textContent = rem === 0 ? 'Free EU shipping unlocked (cart + this order: ' + money(after) + ')' : money(rem) + ' more for free EU shipping (cart + this order: ' + money(after) + ')';
      $('[data-qo-meter]', root).style.width = (threshold ? Math.min(100, Math.round(after / threshold * 100)) : 0) + '%';
      $('[data-qo-submit]', root).disabled = !c.items.length;
    }

    $('[data-qo-add-rows]', root).addEventListener('click', function () { for (var i = 0; i < 5; i++) addRow(); });
    $('[data-qo-clear]', root).addEventListener('click', function () { rowsEl.innerHTML = ''; for (var i = 0; i < 5; i++) addRow(); totals(); });
    $('[data-qo-submit]', root).addEventListener('click', function () {
      var c = collect(); if (!c.items.length) return;
      var b = this, status = $('[data-qo-status]', root);
      busy(b, true); status.textContent = 'Adding ' + c.items.length + ' lines…';
      addItems(c.items).then(function () { return afterAdd(c.items.length + ' lines added'); })
        .then(function (cart) {
          cartTotal = cart.total_price; status.innerHTML = 'Added. <a href="' + esc(T.cartUrl || '/cart') + '">Review cart and check out →</a>';
          rowsEl.innerHTML = ''; for (var i = 0; i < 5; i++) addRow(); totals();
        })
        .catch(function (err) { status.textContent = err.message; })
        .then(function () { busy(b, false); totals(); });
    });

    /* tabs */
    var tabs = $$('[data-qo-tab]', root);
    function showTab(name) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-qo-tab') === name ? 'true' : 'false'); });
      $$('[data-qo-panel]', root).forEach(function (p) { p.hidden = p.getAttribute('data-qo-panel') !== name; });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { showTab(t.getAttribute('data-qo-tab')); }); });

    /* paste list → matched rows */
    $('[data-qo-paste]', root).addEventListener('click', function () {
      var lines = $('#qo-paste-text').value.split(/\n+/).map(function (l) { return l.trim(); }).filter(Boolean).slice(0, 60);
      if (!lines.length) return;
      var b = this; busy(b, true);
      // drop empty rows first
      $$('[data-qo-row]', rowsEl).forEach(function (r) { if (!r.querySelector('[data-qo-q]').value.trim()) r.remove(); });
      var jobs = lines.map(function (line) {
        var m = line.match(/^(.*?)[,;\t ]+(\d{1,3})\s*(?:x|pcs|units?)?$/i);
        var q = (m ? m[1] : line).trim(), qty = m ? Number(m[2]) : 1;
        return suggest(q).then(function (list) {
          var exact = list.filter(function (p) { return p.variants && p.variants.some(function (v) { return v.sku && v.sku.toLowerCase() === q.toLowerCase(); }); })[0];
          var p = exact || list[0];
          return { q: q, qty: qty, handle: p && p.handle, title: p && p.title, sku: (exact || /^\d{3,}-[a-z0-9-]+$/i.test(q)) ? q.toUpperCase() : null };
        }).catch(function () { return { q: q, qty: qty }; });
      });
      Promise.all(jobs).then(function (res) {
        res.forEach(function (r) { addRow(r); });
        showTab('form');
        var miss = res.filter(function (r) { return !r.handle; }).length;
        $('[data-qo-status]', root).textContent = (res.length - miss) + ' of ' + res.length + ' lines matched' + (miss ? ' — check the unmatched rows' : '') + '.';
      }).then(function () { busy(b, false); });
    });

    for (var i = 0; i < 5; i++) addRow();
    totals();
    Smart.warm();
  })();

  /* ---------- botanical dictionary: load all pages, A–Z, filter ---------- */
  (function () {
    var root = $('[data-dict]');
    if (!root) return;
    var input = $('[data-dict-filter]');
    var count = $('[data-dict-count]');
    var az = $('[data-dict-az]', root);
    function run() {
      var items = $$('[data-dict-item]', root);
      var q = input ? input.value.trim().toLowerCase() : '', shown = 0;
      items.forEach(function (li) { var ok = !q || li.getAttribute('data-search').indexOf(q) > -1; li.hidden = !ok; if (ok) shown++; });
      $$('[data-dict-group]', root).forEach(function (g) { g.hidden = !$$('[data-dict-item]:not([hidden])', g).length; });
      if (count) count.textContent = shown + ' of ' + items.length + ' botanicals';
    }
    function relinkAZ() {
      if (!az) return;
      $$('[data-letter]', az).forEach(function (el) {
        var l = el.getAttribute('data-letter');
        if (el.tagName === 'SPAN' && document.getElementById('letter-' + l)) {
          var a = document.createElement('a'); a.href = '#letter-' + l; a.textContent = l; a.setAttribute('data-letter', l); el.replaceWith(a);
        }
      });
    }
    function merge(html) {
      var d = document.createElement('div'); d.innerHTML = html;
      $$('[data-dict-group]', d).forEach(function (g) {
        var mine = document.getElementById(g.id);
        if (mine) { var ul = $('.dict-list', mine); $$('[data-dict-item]', g).forEach(function (li) { ul.appendChild(li); }); return; }
        var after = null;
        $$('[data-dict-group]', root).forEach(function (x) { if (x.id < g.id) after = x; });
        if (after) after.after(g); else if (az) az.after(g); else root.prepend(g);
      });
    }
    var pages = az ? Number(az.getAttribute('data-pages')) || 1 : 1;
    var cur = az ? Number(az.getAttribute('data-current')) || 1 : 1;
    var sid = root.getAttribute('data-section');
    if (input) input.addEventListener('input', run);
    run();
    if (pages > 1 && cur === 1 && sid) {
      var pag = $('[data-dict-pagination]', root);
      if (pag) pag.hidden = true;
      if (count) count.textContent = 'Loading all botanicals…';
      var jobs = [];
      for (var p = 2; p <= pages; p++) {
        jobs.push(fetch(window.location.pathname + '?' + encodeURIComponent(az.getAttribute('data-param') || 'page') + '=' + p + '&section_id=' + encodeURIComponent(sid)).then(function (r) { return r.text(); }));
      }
      Promise.all(jobs).then(function (htmls) {
        htmls.forEach(merge); relinkAZ();
        $$('.dict-list', root).forEach(function (ul) {
          $$('[data-dict-item]', ul).sort(function (a, b) { return a.textContent.trim().localeCompare(b.textContent.trim()); }).forEach(function (li) { ul.appendChild(li); });
        });
        run();
      })
        .catch(function () { if (pag) pag.hidden = false; run(); });
    }
  })();
})();
